import { render } from "./scenario-reviews.vue?vue&type=template&id=26c783bc&ts=true"
import script from "./scenario-reviews.vue?vue&type=script&lang=ts"
export * from "./scenario-reviews.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__